import {
  ChefMenuItem,
  CreateChefMenuItemReq,
  EditChefMenuItemReq,
} from 'types/groupOrder/menuItemMods'

interface GetChefMenuItemCoordinator {
  RestService: {
    get: (path: string) => Promise<ChefMenuItem>
  }
  HandleError: any
  pResponseChefMenuItem: (chefMenuItem: ChefMenuItem) => ChefMenuItem
}

export const GetChefMenuItem =
  ({ RestService, pResponseChefMenuItem }: GetChefMenuItemCoordinator) =>
  async (chefMenuItemId: string): Promise<ChefMenuItem | null> => {
    try {
      const menuItem = await RestService.get(
        `group-orders/chef-menu-items/${chefMenuItemId}`,
      )

      return pResponseChefMenuItem(menuItem)
    } catch (error) {
      return null
    }
  }

interface CreateChefMenuItemCoordinator {
  RestService: {
    post: (path: string, req: CreateChefMenuItemReq) => Promise<ChefMenuItem>
  }
  HandleError: any
  pResponseChefMenuItem: (chefMenuItem: ChefMenuItem) => ChefMenuItem
}

export const CreateChefMenuItem =
  ({
    RestService,
    HandleError,
    pResponseChefMenuItem,
  }: CreateChefMenuItemCoordinator) =>
  async (req: CreateChefMenuItemReq): Promise<ChefMenuItem | null> => {
    try {
      const menuItem = await RestService.post(
        `group-orders/chef-menu-items`,
        req,
      )

      return pResponseChefMenuItem(menuItem)
    } catch (error) {
      HandleError({ error })

      return null
    }
  }

interface EditChefMenuItemCoordinator {
  RestService: {
    put: (path: string, req: EditChefMenuItemReq) => Promise<ChefMenuItem>
  }
  HandleError: any
  pResponseChefMenuItem: (chefMenuItem: ChefMenuItem) => ChefMenuItem
}

export const EditChefMenuItem =
  ({
    RestService,
    HandleError,
    pResponseChefMenuItem,
  }: EditChefMenuItemCoordinator) =>
  async (req: EditChefMenuItemReq): Promise<ChefMenuItem | null> => {
    try {
      const menuItem = await RestService.put(
        `group-orders/chef-menu-items/${req.id}`,
        req,
      )

      return pResponseChefMenuItem(menuItem)
    } catch (error) {
      HandleError({ error })

      return null
    }
  }
